import { createCipheriv as createCipherivUtil, createDecipheriv as createDecipherivUtil, } from 'browserify-aes';
import aesModes from 'browserify-aes/modes';
import { sha1, md5 } from '@noble/hashes/legacy.js';
import { utf8ToBinary } from '../binaryUtils';
import { publicEncrypt as publicEncryptUtil, privateDecrypt as privateDecryptUtil, } from 'public-encrypt';
export function getSubtle() {
    const { crypto } = globalThis;
    if (!crypto?.subtle) {
        const url = 'https://developer.mozilla.org/en-US/docs/Web/API/SubtleCrypto';
        throw new Error(`SubtleCrypto not supported. This feature is available only in secure contexts (HTTPS). ${url}`);
    }
    return crypto.subtle;
}
export function computeMd5(input) {
    return Buffer.from(md5(utf8ToBinary(input)));
}
export function computeSha1(input) {
    return Buffer.from(sha1(utf8ToBinary(input)));
}
export function createCipheriv(algorithm, key, iv) {
    const suite = algorithm.toLowerCase();
    if (aesModes[suite]) {
        return createCipherivUtil(suite, key, iv);
    }
    throw new TypeError(`Invalid suite type.  In browser only AES is supported but got ${algorithm}.`);
}
export function createDecipheriv(algorithm, key, iv) {
    const suite = algorithm.toLowerCase();
    if (aesModes[suite]) {
        return createDecipherivUtil(suite, key, iv);
    }
    throw new TypeError(`Invalid suite type.  In browser only AES is supported but got ${algorithm}.`);
}
export function publicEncrypt(publicKey, buffer) {
    return publicEncryptUtil(publicKey, buffer);
}
export function privateDecrypt(privateKey, buffer) {
    return privateDecryptUtil(privateKey, buffer);
}
